"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SenderSelect/Option.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Avatar = require('web/components/Avatar');
var _keyboard = require('web/services/keyboard');







const Option = ({ entity, onSelect, isSelected }) => (
  _react2.default.createElement('div', {
    role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
    onClick: onSelect,
    className: "sender-select--option", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}

    , _react2.default.createElement(_Avatar.EntityAvatar, {
      entity: entity,
      size: 30,
      className: "sender-select--option--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    )
    , _react2.default.createElement('div', { className: "sender-select--option--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      , _react2.default.createElement('span', { className: "sender-select--option--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  entity.name )
      , _react2.default.createElement('span', { className: "sender-select--option--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
        ,  entity.description 
      )
    )
    ,  isSelected && (
      _react2.default.createElement('div', { className: "sender-select--option--selected-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
    )
  )
)

exports. default = Option
